module.exports = __webpack_public_path__ + "static/media/to_khai_suc_khoe.2399ccc5.pdf";